import { buildInventory, setInventoryFunctions } from "./inventory";
import { buildHyruleField, buildShadowTemple, buildForestTemple, buildWaterTemple, buildSpiritTemple, buildFireTemple, setDefaultFunctions, setForestFunctions, setShadowFunctions, setSpiritFunctions, setDefaultDataFunctions, setSpiritDataFunctions } from "./temples";
import { buildControls, setControlFunctions } from "./controls";
import { generateUUID } from "./utilities";

export function buildData() {
    var data;
    if(localStorage.getItem('puzzleData')) {
        data = JSON.parse(localStorage.getItem('puzzleData')).data;
    }
    else {
        data = {
            inventory: buildInventory(),
            controls: buildControls(),
            hyruleField: buildHyruleField(),
            shadowTemple: buildShadowTemple(),
            forestTemple: buildForestTemple(),
            waterTemple: buildWaterTemple(),
            spiritTemple: buildSpiritTemple(),
            fireTemple: buildFireTemple(),
            sessionId: generateUUID()
        }
        /* eslint-disable no-undef */
        gtag('event', 'started', {
            'event_category' : 'sudoku',
            'event_label' : 'started',
            'value': data.sessionId
        });
    }
    
    if(!data.sessionId) data.sessionId = generateUUID();
    setDefaultFunctions(data.hyruleField);
    setDefaultFunctions(data.waterTemple);
    setDefaultFunctions(data.fireTemple);
    setForestFunctions(data.forestTemple);
    setShadowFunctions(data.shadowTemple);
    setSpiritFunctions(data.spiritTemple);

    setDefaultDataFunctions(data.hyruleField);
    setDefaultDataFunctions(data.forestTemple);
    setDefaultDataFunctions(data.shadowTemple);
    setDefaultDataFunctions(data.waterTemple);
    setDefaultDataFunctions(data.fireTemple);
    setSpiritDataFunctions(data.spiritTemple);

    setInventoryFunctions(data.inventory);
    setControlFunctions(data.controls);

    return data;
}